import { Button, Flex, Heading, useColorMode } from '@chakra-ui/core';
import localStorage from 'localstorage-ttl';
import { useObserver } from 'mobx-react';
import React, { useEffect } from 'react';
import { FaFacebook, FaGoogle, FaSpotify } from 'react-icons/fa';
import { useHistory } from 'react-router';

import { useStores } from '../hooks/useStores';
import { AuthProviders } from '../types/shared';
import config from '../utils/config';

const useStoreData = () => {
    const { store } = useStores();
    return useObserver(() => ({
        signInGuest: store.auth.signInGuest,
        isAuthenticated: store.auth.isAuthenticated,
        signInGuesWithSpotify: store.auth.signInGuesWithSpotify,
    }));
};

const SignInGuest: React.FC = () => {
    const { signInGuest, isAuthenticated, signInGuesWithSpotify } = useStoreData();
    const { colorMode } = useColorMode();
    const history = useHistory();
    const bgColor = { light: 'gray.50', dark: 'gray.800' };
    const color = { light: 'gray.800', dark: 'gray.50' };
    useEffect(() => {
        if (!isAuthenticated && !localStorage.get(config.LOCAL_STORAGE_PARTY_LINK_TO_REDIRECT)) {
            history.replace('/signin');
            return;
        }
        if (isAuthenticated) {
            history.replace(localStorage.get(config.LOCAL_STORAGE_PARTY_LINK_TO_REDIRECT));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated]);
    return (
        <Flex
            direction="column"
            bg={bgColor[colorMode]}
            color={color[colorMode]}
            minH="100vh"
            alignItems="center"
            justifyContent="center"
        >
            <Heading m="1rem">One Playlist</Heading>
            <Button size="lg" variant="ghost" rightIcon={FaGoogle} onClick={() => signInGuest(AuthProviders.GOOGLE)}>
                Sign in with
            </Button>
            <Button size="lg" variant="ghost" rightIcon={FaFacebook} onClick={() => signInGuest(AuthProviders.FACEBOOK)}>
                Sign in with
            </Button>
            <Button size="lg" variant="ghost" rightIcon={FaSpotify} onClick={() => signInGuesWithSpotify()}>
                Sign in with
            </Button>
        </Flex>
    );
};

export default SignInGuest;
